<template>
  <div class="Financial_box">
    <div class="title">{{userinfo.unit_name}}的财务情况 ({{ year }}年度)</div>

    <div>
      <el-descriptions :column="2" border>
        <el-descriptions-item
          v-for="(item, index) in list"
          :key="index"
          :label-class-name="'labelclass' + item.level"
          content-class-name="my-content"
          span="2"
        >
          <template slot="label">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <div>
                <span class="index_box"> {{ item.id }}</span>
              </div>
              <div>
                <span style="color: #e60013" v-if="item.show">*</span>
                {{ item.label }}
              </div>
            </div>
          </template>
          <div :class="getClassName(item.check)">
            <el-input-number
              :controls="false"
              :precision="4"
              v-model="item.value"
              @blur="check(item, index)"
              :placeholder="item.placeholder ? item.placeholder : '请输入金额'"
              :disabled="item.disabled"
            >
            </el-input-number>
            <span
              class="checkname"
              v-if="item.checkname && item.checkname != ''"
              >{{ item.checkname }}</span
            >
          </div>
        </el-descriptions-item>
      </el-descriptions>
      <div class="upload_allbox">
        <upload :list="uploadlist"></upload>
        <div class="checkimg" v-if="uploadlist.imglist.length == 0 && checkimg">
          请上传相关资质!
        </div>
        <div style="margin-left: 19px" v-if="uploadlist.imglist.length == 0">
          <p>请上传相关资质</p>
          <p style="font-size: 14px; color: #7c7c7c">
            (图片或者PDF，500k以内, 图像清晰，比例合理，不变形。可以多传)
          </p>
        </div>
      </div>
      <div class="button_box" v-if="!bc">
        <el-button
          type="primary"
          @click="Submit"
          :loading="loading"
          :disabled="bc"
          >保 存</el-button
        >
      </div>
      <div class="luoji_box">
        逻辑关系为：<span>11=31+32+33+34+35+36 </span>&nbsp;&nbsp;&nbsp;<span>
          31=41+42
        </span>
        &nbsp;&nbsp;&nbsp;<span> 17≧37+38 25=17-18 </span>
      </div>
    </div>
  </div>
</template>
<script>
import upload from "@/components/upload.vue";
export default {
  components: {
    upload: upload,
  },
  data() {
    return {
      userinfo:JSON.parse(localStorage.getItem("info")),

      loading: false, //节流
      timerId: null,
      bc: false,
      year: "",
      info: {},
      list: [
        {
          value: undefined, //定义的值
          label: "一、营业收入合计(万元)：", //显示的名称
          name: "trade_total", //后台变量
          level: "a", //标题等级
          placeholder: "根据以下填写数据自动计算", //默认提示
          disabled: true, //是否禁用
          show: true, //是否开启校验
          check: false, //校验提示类添加
          // checkname: '',//规则展示
          id: 11, //自身表示用于计算
          count: [31, 32, 33, 34, 35, 36], //计算的变量
          counttype: "+", //计算的类型 + -
        },
        {
          value: undefined,
          label: "1.招标代理收入(万元)",
          name: "trade_zb",
          level: "b",
          placeholder: "根据以下填写数据自动计算", //默认提示
          disabled: true,
          show: true,
          check: false,
          id: 31,
          counttype: "+", //计算的类型 + -
          count: [41, 42],
        },
        {
          value: undefined,
          label: "a.工程招标代理收入(万元)",
          name: "trade_gc",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 41,
        },
        {
          value: undefined,
          label: "b.采购代理收入(万元)",
          name: "trade_cg",
          level: "c",
          disabled: false,
          show: true,
          check: false,
          id: 42,
        },
        {
          value: undefined,
          label: "2.工程造价咨询收入(万元)",
          name: "trade_zjzx",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 32,
        },
        {
          value: undefined,
          label: "3.工程监理收入(万元)",
          name: "trade_gcjl",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 33,
        },
        {
          value: undefined,
          label: "4.工程设计收入(万元)",
          name: "trade_gcsj",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 34,
        },
        {
          value: undefined,
          label: "5.全过程工程咨询服务收入(万元)",
          name: "trade_qgc",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 35,
        },
        {
          value: undefined,
          label: "6.其他收入(万元)",
          name: "trade_other",
          level: "b",
          disabled: false,
          show: true,
          check: false,
          id: 36,
        },

        {
          value: undefined,
          label: "二、营业成本(万元)：",
          name: "cost",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 12,
        },

        {
          value: undefined,
          label: "三、营业税金及附加(万元)：",
          name: "taxes",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 13,
        },

        {
          value: undefined,
          label: "四、管理费用(万元)：",
          name: "manage",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 14,
        },

        {
          value: undefined,
          label: "五、营业利润(万元)：",
          name: "profit",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 15,
        },
        {
          value: undefined,
          label: "六、应付职工薪酬(万元)：",
          name: "pay",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 16,
        },
        {
          value: undefined,
          label: "七、资产合计(万元)：",
          name: "assets_total",
          level: "a",
          placeholder: "根据以下填写数据自动计算", //默认提示
          disabled: true,
          check: false,
          show: true,
          id: 17,
          counttype: "+", //计算的类型 + -
          count: [37, 38],
        },
        {
          value: undefined,
          label: "固定资产(万元)",
          name: "assets_regular",
          level: "c",
          disabled: false,
          check: false,
          show: true,
          id: 37,
        },
        {
          value: undefined,
          label: "流动资产(万元)",
          name: "assets_assets",
          level: "c",
          disabled: false,
          check: false,
          show: true,
          id: 38,
        },

        {
          value: undefined,
          label: "八、负债合计(万元)：",
          name: "debt_total",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 18,
        },
        {
          value: undefined,
          label: "九、销售费用(万元)：",
          name: "sale_money",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 19,
        },
        {
          value: undefined,
          label: "十、财务费用(万元)：",
          name: "finance_money",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 20,
        },
        {
          value: undefined,
          label: "十一、公允价值变动收益(万元)：",
          name: "change",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 21,
        },
        {
          value: undefined,
          label: "十二、投资收益(万元)：",
          name: "invest",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 22,
        },
        {
          value: undefined,
          label: "十三、营业外收入(万元)：",
          name: "nonbusi",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 23,
        },
        {
          value: undefined,
          label: "十四、利润总额(万元)：",
          name: "profit_total",
          level: "a",
          disabled: false,
          check: false,
          show: true,
          id: 24,
        },
        {
          value: undefined,
          label: "所得税(万元)",
          name: "tax",
          level: "c",
          disabled: false,
          check: false,
          show: true,
          id: 39,
        },
        {
          value: undefined,
          label: "十五、所有者权益合计(万元)：",
          name: "equity",
          level: "a",
          placeholder: "根据资产合计减去负债合计自动计算结果",
          disabled: true,
          check: false,
          show: true,
          id: 25,
          counttype: "-", //计算的类型 + -
          count: [17, 18],
        },
      ],
      uploadlist: {
        imglist: [],
        listLengthTag: false, //超出隐藏,初始化
        limit: 100,
        disabled: false,
      },
      checkimg: false,
    };
  },
  watch: {
    list: {
      handler(val, oldval) {
        // console.log(val, oldval, '-=-=');
        this.handcount(val, oldval);
      },

      // 深度观察监听
      deep: true,
    },
  },
  computed: {},
  created() {
    // this.$route.query.isshow = 'show'
  },
  mounted() {
    this.init();
  },
  methods: {
    //获取访问状态
    init() {
      let that = this;
      let data = {};
      that.$http.post("institution/basicqk/getStatus", data).then((res) => {
        if (res.code == 1) {
          if (res.data == 2) {
            for (let i = 0; i < this.list.length; i++) {
              this.list[i]["disabled"] = true;
            }
            this.bc = true;
            this.uploadlist.disabled = true;
          }
          this.getinfo();
        }
      });
    },
    //获取列表
    getinfo() {
      let that = this;
      let data = {
        year: this.year ? this.year : "",
      };
      that.$http.post("institution/finance/getDetail", data).then((res) => {
        if (res.code == 1) {
          that.info = res.data;
          this.year = this.$route.query.year
            ? this.$route.query.year
            : this.info.year;
          for (const [key, value] of Object.entries(res.data)) {
            for (let i = 0; i < this.list.length; i++) {
              if (this.list[i].name && this.list[i].name == key) {
                this.list[i].value = value == null ? undefined : Number(value);
              }
            }
          }

          const newlist = this.$self.showimg(
            JSON.parse(JSON.stringify(this.uploadlist)),
            res.data.files
          );
          // console.log(newlist)
          this.uploadlist = newlist;
        }
      });
    },
    //失去焦点改变输入框的状态
    check(item, index) {
      for (let i = 0; i < this.list.length; i++) {
        if (index == i) {
          // console.log(this.list[i].value, '失去焦点')
          if (this.list[i].value == undefined) {
            this.list[i].value = undefined;
            this.list[i]["check"] = true;
          } else {
            this.list[i]["check"] = false;
          }
        }
      }
    },
    //校验动态添加类名
    getClassName(item) {
      // 动态生成类名的逻辑
      if (item) {
        return "check";
      } else {
        return "";
      }
    },
    //计算公式
    handcount(val, oldval) {
      // console.log(val, oldval, '-=-=')
      for (let i = 0; i < val.length; i++) {
        let arr = [];
        if (val[i].count && val[i].count.length > 0) {
          for (let y = 0; y < val[i].count.length; y++) {
            for (let z = 0; z < val.length; z++) {
              if (val[z].id == val[i].count[y]) {
                arr.push(val[z].value);
              }
            }
          }
          const filteredArray = arr.filter(
            (item) => typeof item !== "undefined"
          );
          // console.log(filteredArray)

          if (val[i].counttype == "+") {
            const sum = filteredArray.reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );
            this.list[i].value = sum;
          }
          if (val[i].counttype == "-") {
            const diff = filteredArray.reduce(
              (accumulator, currentValue) => accumulator - currentValue
            );
            this.list[i].value = diff;
          }
        }
      }
    },
    //保存
    Submit() {
      this.loading = true;
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      this.timerId = setTimeout(() => {
        this.loading = false; //之后放到接口
        let valid = true;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].value == undefined) {
            this.list[i]["check"] = true;
            valid = false;
          } else {
            this.list[i]["check"] = false;
            valid = true;
          }
        }
        if (this.uploadlist.imglist.length == 0) {
          valid = false;
          this.checkimg = true;
        }
        // console.log(this.checkimg)

        if (valid) {
          // console.log(this.list)
          let obj = {};
          this.list.forEach((item, index) => {
            obj[item.name] = item.value ? item.value : 0;
          });
          let that = this;
          let data = {
            year: this.year ? this.year : "",
            id: this.info.id,
            files: this.$self.editimglist(this.uploadlist.imglist).join(","),
          };
          data = { ...data, ...obj };
          that.$http.post("institution/finance/getEdit", data).then((res) => {
            this.$self.ts(res).then(() => {
              this.init();
            });
          });
        } else {
          // console.log("填写完整信息");
        }
        clearTimeout(this.timerId);
      }, 500); // 设置延迟时间，单位为毫秒
    },
  },
};
</script>
<style scoped>
.luoji_box {
  padding: 26px 28px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #f77e88;
}
.Financial_box {
  margin: 20px 20px;
}

.title {
  height: 40px;
  background: #1954a4;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-descriptions-item__content {
  padding: 0 !important;
}
::v-deep .el-descriptions .is-bordered .el-descriptions-item__cell {
  padding: 12px 10px 12px 20px;
}
::v-deep .el-input-number {
  width: 100%;
  height: 100%;
}

::v-deep .el-input__inner {
  height: 51px;
  border: none;
  text-align: left;
  font-size: 16px;
  color: #333;
}

::v-deep .el-input.is-disabled .el-input__inner {
  color: #333;
  background: #fff;
}

::v-deep .is-bordered-label {
  width: 370px;
  text-align: end !important;
  font-size: 16px;
  font-family: Microsoft YaHei;
  background: #fff;
}

.check ::v-deep .el-input .el-input__inner::placeholder {
  color: #e60013 !important;
}

.check ::v-deep .el-input .el-input__inner {
  color: #e60013 !important;
}

.check {
  position: relative;
}

.checkname {
  position: absolute;
  top: 39%;
  right: 3%;
  color: #e60013;
}

.upload_allbox {
  margin: 20px 0px 0;
  background: #fff;
  border: 1px solid #f2f2f2;
  display: flex;
  align-items: center;
  padding: 30px 0.175rem;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  position: relative;
}

.checkimg {
  position: absolute;
  top: 39%;
  right: 5%;
  color: #e60013;
}

.upload_allbox ::v-deep .el-upload--picture-card {
  width: 71px;
  height: 71px;
  line-height: 80px;
  background: #fafafa;
}

.upload_allbox ::v-deep.el-upload--picture-card i {
  font-size: 22px;
}

.upload_allbox ::v-deep.el-upload-list--picture-card .el-upload-list__item {
  width: 71px;
  height: 71px;
}

.button_box {
  padding: 20px;
  background: #fafafa;
  border: 1px solid #f2f2f2;
}
.index_box {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  position: relative;
}
.index_box::after {
  content: "";
  position: absolute;
  top: -59%;
  right: -133%;
  width: 1px;
  background: #e4e7ed;
  height: 212%;
}
</style>
<style>
.labelclassa {
  font-weight: bold !important;
  color: #1954a4 !important;
  position: relative;
}

.labelclassb {
  font-weight: bold !important;
  color: #333333 !important;
  position: relative;
}

.labelclassc {
  color: #333333 !important;
  font-weight: 400 !important;
  position: relative;
}
</style>
  